import DestinationPicker from "../components/destinationPicker.jsx";
import DeparturePicker from "../components/departurePicker.jsx";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import DatePicker from "../components/datePicker.jsx";
import PaxPicker from "../components/paxPicker.jsx";
import PackageDatasource from "../datasources/packageDatasource.js";
import PopoverInput from "../components/inner/popoverInput.jsx";
import useWindowDimensions from "../helpers/Hooks/useWindowDimensions";
import useJsonCookie from "../helpers/Hooks/useJsonCookie.jsx";
import { format, parse, differenceInDays } from "date-fns";

import { IsMobileContext, DataSourceContext } from '../context/contexts.jsx'
const DEFAULT_ROOMS = [{ adults: 2, children: [], infants: 0 }];
const serializeRooms = (rooms) => {

    let roomDefs = [];
    for (let i = 0; i < rooms.length; i++) {
        let myUrlSlug = "";
        const room = rooms[i];
        myUrlSlug = myUrlSlug + `A${room.adults}`;
        if (room.children.length > 0) {
            for (let c = 0; c < room.children.length; c++) {
                const childAge = room.children[c];
                myUrlSlug = myUrlSlug + `C${childAge}`;
            }
        }
        if (room.infants > 0) {
            myUrlSlug = myUrlSlug + `I${room.infants}`;
        }
        roomDefs.push(myUrlSlug);
    }
    return roomDefs.join('-');
}
const deserializeRooms = (roomsString) => {
    if (!roomsString) {
        return DEFAULT_ROOMS;
    }

    const roomDefs = roomsString.split('-');
    const rooms = [];

    for (let i = 0; i < roomDefs.length; i++) {
        const roomDef = roomDefs[i];
        const room = { adults: 0, children: [], infants: 0 };

        // Match pattern: A2C5C7I1 (adults, children with ages, infants)
        const adultsMatch = roomDef.match(/A(\d+)/);
        const childrenMatches = roomDef.matchAll(/C(\d+)/g);
        const infantsMatch = roomDef.match(/I(\d+)/);

        if (adultsMatch) {
            room.adults = parseInt(adultsMatch[1], 10);
        }

        for (const childMatch of childrenMatches) {
            room.children.push(parseInt(childMatch[1], 10));
        }

        if (infantsMatch) {
            room.infants = parseInt(infantsMatch[1], 10);
        }

        rooms.push(room);
    }

    return rooms;
}
const SearchOverview = ({ departures, destination, datesText, openSearch, isMobile }) => {
    return <div className="">
        {isMobile && (
            <button onClick={() => openSearch()} type="button"
                className="btn-primary text-white p-2 inline-flex items-center justify-center rounded-full bg-emp">
                <span className="h-[32px] flex items-center justify-center px-4">Edit Search</span>
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.8043 11.25L12.9293 12.375M13.2543 14.2689C12.821 13.8356 12.821 13.1332 13.2543 12.7C13.6875 12.2667 14.3899 12.2667 14.8232 12.7L16.3543 14.2311C16.7876 14.6644 16.7876 15.3668 16.3543 15.8C15.9211 16.2333 15.2187 16.2333 14.7854 15.8L13.2543 14.2689ZM12.9293 7.125C12.9293 4.22551 10.5788 1.875 7.67932 1.875C4.77983 1.875 2.42932 4.22551 2.42932 7.125C2.42932 10.0245 4.77983 12.375 7.67932 12.375C10.5788 12.375 12.9293 10.0245 12.9293 7.125Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
            </button>
        )}
    </div>;
}

const OlympicSearch = ({ overviewNode, specificSearch, specificAccom, baseUrl, bookingEngineBaseUrl }) => {
    if (specificSearch && specificAccom) {
        throw new Error("cannot do both");
    }
 
    const [savedRooms, setSavedRooms, removeSavedRooms] = useJsonCookie('s_rooms', DEFAULT_ROOMS, baseUrl);
    const [savedDeparture, setSavedDeparture, removeSavedDeparture] = useJsonCookie("s_dep", null, baseUrl);
    const [savedDestination, setSavedDestination, removeSavedDestination] = useJsonCookie("s_dest", null, baseUrl);
    const [savedStartDate, setSavedStartDate, removeStartDate] = useJsonCookie("s_from_date", null, baseUrl);
    const [savedToDate, setSavedToDate, removeToDate] = useJsonCookie("s_to_date", null, baseUrl);

    const [rooms, setRooms] = useState(savedRooms);
    const [departures, setDepartures] = useState([]);
    const [destination, setDestination] = useState(null);
    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [overViewDepartureText, setOverViewDepartureText] = useState();
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const { height, width } = useWindowDimensions();
    const isMobile = width < 1067;
    var dataSource = PackageDatasource.getDataSource("packages", baseUrl);

    useEffect(() => {

        var departureToUse = savedDeparture;
        var destinationInUse = savedDestination;
        var startDateToUse = savedStartDate ? parse(savedStartDate, "yyyy-MM-dd", new Date()) : null;
        var endDateToUse = savedToDate ? parse(savedToDate, "yyyy-MM-dd", new Date()) : null;
        if (specificSearch) {
            departureToUse = specificSearch.dep;
            destinationInUse = specificSearch.to;
            startDateToUse = parse(specificSearch.startDate, "yyyy-MM-dd", new Date());
            endDateToUse = parse(specificSearch.endDate, "yyyy-MM-dd", new Date());
            const roomsFromString = deserializeRooms(specificSearch.pax);
            setRooms(roomsFromString);

        } else if (specificAccom) {
            destinationInUse = specificAccom.code;
        }

        async function fetchData() {
            var validateResponse = await dataSource.validate(departureToUse, destinationInUse?.code, startDateToUse, endDateToUse);

            if (validateResponse.isValidDeparture) {
                setDepartures(departureToUse);
            }
            if (validateResponse.isValidDestination) {
                setDestination(validateResponse.destinationModel);
            }
            if (validateResponse.isValidDates) {
                setSelectedFromDate(startDateToUse);
                setSelectedToDate(endDateToUse)
            }
        }
        if (departureToUse && departureToUse.length > 0 && destinationInUse && startDateToUse && endDateToUse) {
            fetchData();
        }
    }, []);



    const submit = () => {
        if (!departures || departures.count == 0) {
            return;
        }
        if (!destination) {
            return;
        }
        if (!selectedFromDate || !selectedToDate) {
            return;
        }

        if (!selectedFromDate || !selectedToDate) {
            return;
        }

        setSavedDeparture(departures);


        if (!specificAccom) {
            setSavedDestination(destination);
        }

        const fromDate = format(selectedFromDate, "yyyy-MM-dd");
        const toDate = format(selectedToDate, "yyyy-MM-dd");
        setSavedStartDate(fromDate);
        setSavedToDate(toDate);
        setSavedRooms(rooms);

        var nights = differenceInDays(selectedToDate, selectedFromDate)
        let roomsString = serializeRooms(rooms);


        let url = `${bookingEngineBaseUrl}/P/${departures.join('-')}/${destination.code}/${nights}/${fromDate}/${fromDate}/${roomsString}`;

        window.location.href = url;
    }

    let portalContent = null;

    if (overviewNode) {
        let datesText = "No Date Selected";
        if (selectedFromDate || selectedToDate) {
            const fromDateStr = selectedFromDate ? format(selectedFromDate, "dd/MM/yyyy") : "";
            const toDateStr = selectedToDate ? format(selectedToDate, "dd/MM/yyyy") : "";

            datesText = `${fromDateStr} - ${toDateStr}`;
        }
        portalContent = createPortal(<SearchOverview isMobile={isMobile} departures={overViewDepartureText} destination={destination?.name} datesText={datesText} openSearch={() => { setIsSearchOpen(!isSearchOpen) }} />, overviewNode);

    }
    var showSearch = !overviewNode || (isSearchOpen || !isMobile);
    return (
        <IsMobileContext value={isMobile}>
            <DataSourceContext value={dataSource}>
                <div className={"bg-white rounded-[24px] relative " + (showSearch ? "" : "hidden")}>
                    <div className=" px-4 py-6" >
                        <div className="flex flex-col lg:flex-row items-center justify-center gap-4">
                            {/* Departure Dropdown */}
                            <DeparturePicker
                                selectedAirports={departures}

                                updateOverviewText={setOverViewDepartureText}
                                onUpdate={setDepartures}
                            />
                            <DestinationPicker
                                departureAirports={departures}

                                accomIsLocked={!!specificAccom}
                                selectedDestination={destination}
                                onUpdate={setDestination}
                            />
                            <DatePicker
                                departureAirports={departures}
                                destination={destination?.code}

                                selectedFrom={selectedFromDate}
                                selectedTo={selectedToDate}
                                onChange={(from, to) => {
                                    setSelectedFromDate(from);
                                    setSelectedToDate(to);
                                }}
                            />
                            <PaxPicker
                                rooms={rooms}
                                onChange={setRooms}
                            />

                            <div className="w-full lg:w-[150px]">
                                <button onClick={() => submit()} type="submit" className="group w-full p-[4px] bg-primary rounded-full pr-[34px] hover:pr-[4px] transition-all duration-200 relative">
                                    <span className="h-[32px] rounded-full bg-white flex items-center justify-center px-4 transition-all duration-200 group-hover:pr-[46px]">Search</span>
                                    <span className="absolute top-[4px] w-[32px] h-[32px] right-[4px] rounded-full bg-white text-primary flex items-center justify-center transition-all duration-200 group-hover:w-[42px] group-hover:pe-[10px]">
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.5 15.0005L17 16.5005M17.4333 19.0257C16.8556 18.448 16.8556 17.5114 17.4333 16.9338C18.0109 16.3561 18.9475 16.3561 19.5252 16.9338L21.5667 18.9753C22.1444 19.553 22.1444 20.4896 21.5667 21.0672C20.9891 21.6449 20.0525 21.6449 19.4748 21.0672L17.4333 19.0257ZM17 9.50049C17 5.6345 13.866 2.50049 10 2.50049C6.13401 2.50049 3 5.6345 3 9.50049C3 13.3665 6.13401 16.5005 10 16.5005C13.866 16.5005 17 13.3665 17 9.50049Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {portalContent}
            </DataSourceContext>
        </IsMobileContext>);
};
export default OlympicSearch;
